module.exports = __webpack_public_path__ + "img/reserved_selected.faf76d5b.svg";